import Axios from 'axios';

import config from '../config.json';

const URI = config.URI;
const DEFAULT_HEADER = { headers: { 'Content-Type': 'application/json' } };
const GET = 'get';
const POST = 'post';

const calling = (url, method, data) => {
  if (method === POST) {
    return Axios.post(url, data, DEFAULT_HEADER).then((response) => {
      return response.data;
    });
  }
  return Axios.get(url, { params: data }, DEFAULT_HEADER).then((response) => {
    return response.data;
  });
};

const callApi = (url, method, data) => {
  return calling(url, method, data);
};

// eslint-disable-next-line import/prefer-default-export
export const getPaymentOrder = (id) => {
  const url = `${URI}/api/payment-order/get-order`;
  return callApi(url, GET, { id });
};
